module.exports = __webpack_public_path__ + "img/blockables-instructions-1.539c68f7.png";